import axios from 'axios'

import TokenHelper from '../_helpers/token.helper'
import { getLanguage, showDialog } from '../_helpers/util'
import fileDownload from 'js-file-download'
let lang = getLanguage()
const API_BASE_URL = `${window.location.origin}/api/${lang}/`
export const getBaseUrl = () => {
  let lang = getLanguage()
  switch (process.env.NODE_ENV) {
    case 'production':
      return API_BASE_URL //`https://question-api.maktabevahy.com/${lang}/`
    // return `https://question-api.motaghin.com/${lang}/`
    case 'development':
    default:
      return `https://localhost:44325/${lang}/`
  }
}
export function changeToken(token = null) {
  axiosInstance.defaults.headers['Token'] = token
}
export function changeLang(lang) {
  switch (process.env.NODE_ENV) {
    case 'production':
      axiosInstance.defaults.baseURL = API_BASE_URL //`https://question-api.maktabevahy.com/${lang}/`
      break
    case 'development':
    default:
      axiosInstance.defaults.baseURL = `https://localhost:44325/${lang}/`
  }
}
let axiosInstance = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-type': 'application/json',
    Token: TokenHelper.getToken(),
  },
})

//اگر بخواهیم پاسخ را بررسی کنیم بطور عمومی
axiosInstance.interceptors.response.use(
  (response) => {
    //alert("jjjjj");
    return response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.message === 'Network Error') {
      // var obj = $.dialog({
      //   title: "هشدار",
      //   content: "دسترسی به شبکه قطع می باشد",
      //   rtl: true,
      //   type: "red",
      //   animation: "top",
      // });
      // setTimeout(function () {
      //   obj.close();
      // }, 1000);
    }
    if (error.response !== undefined && error.response?.data !== undefined)
      showDialog('هشدار', error.response?.data, 'red', 2000)
    return Promise.reject(error)
  }
)

//بخواهیم چیزی به درخواست اضافه کنیم بطور عمومی
axiosInstance.interceptors.request.use(
  (request) => {
    //alert("jjjjj");
    return request
  },
  function (error) {
    return Promise.reject(error)
  }
)
// تابع برای ارسال درخواست و دریافت فایل
export async function downloadExcel(data, url, fileName = '') {
  try {
    const response = await axios.post(`${getBaseUrl()}${url}`, data, {
      responseType: 'blob', // دریافت باینری
      headers: {
        'Content-Type': 'application/json',
        Token: TokenHelper.getToken(),
      },
    })

    fileName = fileName === '' ? 'question.xlsx' : fileName + '.xlsx'

    fileDownload(response.data, fileName)
  } catch (error) {
    console.error('خطا در دریافت فایل اکسل', error)
  }
}

export default axiosInstance
